import { Button } from "@/components/ui/button";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { Menu } from "lucide-react";
import { NavLink, NavMenu } from "./nav-menu";
import React from "react";

type NavigationSheetProps = {
    links: NavLink[];
};

export const NavigationSheet = ({ links }: NavigationSheetProps) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="outline" size="icon" className="rounded-full">
                    <Menu />
                </Button>
            </PopoverTrigger>
            <PopoverContent
                sideOffset={0}
                className="w-[calc(var(--radix-popover-content-available-width)---spacing(8))] mx-4 mt-6 p-0 overflow-hidden"
                align="end"
            >
                <NavMenu
                    className="container max-w-none *:w-full"
                    orientation="vertical"
                    links={links}
                />
            </PopoverContent>
        </Popover>
    );
};
